import dayjs from "dayjs";

import OverheadExpenseDto from "../../dto/OverheadExpenses/OverheadExpenseDto";
import AttachDocumentModel, { AttachDocumentDataConverter } from "../Documents/AttachDocumentModel";
import { EditOverheadExpenseFormInputModel } from "../../containers/AccountantPages/OverheadExpensesPage/components/EditDrawer";

type OverheadExpenseModel = Omit<OverheadExpenseDto, "date" | "documents"> & {
  date: dayjs.Dayjs;
  documents: Array<AttachDocumentModel>;
};

export type UpdateOverheadExpenseModel = OverheadExpenseDto;
export type CreateOverheadExpenseModel = Omit<OverheadExpenseDto, "id">;

export class OverheadExpenseDataConverter {
  static convertOverheadExpense(overheadExpense: OverheadExpenseDto): OverheadExpenseModel {
    return {
      ...overheadExpense,
      date: dayjs(overheadExpense.date),
    };
  }

  static convertOverheadExpenses(overheadExpenses: Array<OverheadExpenseDto>): Array<OverheadExpenseModel> {
    return overheadExpenses.map((x) => this.convertOverheadExpense(x));
  }

  static convertOverheadExpenseForUpdate(overheadExpense: EditOverheadExpenseFormInputModel): UpdateOverheadExpenseModel {
    return {
      ...overheadExpense,
      date: overheadExpense.date.format("YYYY-MM-DD"),
      documents: AttachDocumentDataConverter.convertDocumentsToUpdate(overheadExpense.documents),
    };
  }
}

export default OverheadExpenseModel;
